
<template>
  <div>
    <div class="cominfo-header">企业中心
      <span>/</span><span>学习计划</span><span>/</span><span>
        <router-link to="/Company/Plan">计划管理</router-link>
      </span><span>/</span><span>{{ruleForm.id?(disabled?'查看':'编辑'):'设置'}}评估项目</span>
    </div>
    <div class="pxpgInfo" v-loading="loading">
      <div class="pxpgInfo-header disFlex between">
        <div>
          请选择评估项目，选择后学员将根据选择的项目对计划进行评估！
        </div>
        <div>
          <el-button type="primary" v-if="!disabled" @click="onSave">保存</el-button>
          <el-button type="primary" v-if="disabled" @click="goBack">返回</el-button>
        </div>
      </div>
      <div class="pxpgInfo-conts" style="background-color: #ffffff;min-height: 50vh;padding: 30px 50px 0;">
        <el-tree ref="pgtrees" :default-expanded-keys="['ZXKT_appraisal_itype_1','ZXKT_appraisal_itype_2','ZXKT_appraisal_itype_3','ZXKT_appraisal_itype_4']" :load="loadNode" @check="changeCheck" :check-strictly="true" lazy show-checkbox
          node-key="uniqueCode" :default-checked-keys="defauleIds" :props="defaultProps">
        </el-tree>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['collapse', 'wjSrc', 'currentUser'],
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('联系方式不能为空！'));
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('联系方式有误，请重新输入！'));
        } else {
          callback();
        }
      };
      return {
        options: [],
        ruleForm: {},
        loading: false,
        defaultProps: {
          children: 'children',
          label: 'text'
        },
        defauleIds:[]
      }
    },
    methods: {
      onSave: function() {
        var checkedNodes = this.$refs.pgtrees.getCheckedNodes();
        var objson = {};
        var planId = this.planId;
        checkedNodes.map((nodes) => {
          var uniqueCode = nodes.uniqueCode;
          if (uniqueCode.split('_').length == 4 && !objson[uniqueCode]) {
            objson[uniqueCode] = {
              itype: nodes.uniqueCode,
              itypeName: nodes.text,
              itemJson: [],
              dataId: planId
            };
          } else {
            var parentCode = uniqueCode.split('_').splice(0, 4).join('_');
            objson[parentCode].itemJson.push({
              id: nodes.uniqueCode,
              name: nodes.text
            })
          }
        });
        var arrlist = [];
        for (var k in objson) {
          objson[k].itemJson = JSON.stringify(objson[k].itemJson);
          arrlist.push(objson[k]);
        };
        var $this = this;
        this.$axios.post('/kt/ktAppraiseItem/addBatch.htm', this.$qs.stringify({
            json: JSON.stringify(arrlist)
          }))
          .then(res => {
            var data = res.data;
            this.loading = false;
            if (data.stat == '1') {
              this.$message({
                message: data.message,
                type: 'success',
                duration: 1000,
                onClose: function() {
                  $this.$router.push('/Company/Plan');
                }
              });
            } else {
              this.$message.error(data.message);
            }
          })
      },
      goBack: function() {
        this.$router.go(-1);
      },
      changeCheck: function(data) {
        var checkedNodes = this.$refs.pgtrees.getCheckedNodes();
        checkedNodes.map((nodes) => {
          this.$refs.pgtrees.setChecked(nodes.parentId, true);
        })
      },
      loadNode(node, resolve) {
        var $this = this;
        if (node.level === 0) {
          this.$axios.get('/system/datadict/tree.htm?supCode=ZXKT_appraisal_itype', {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            }
          }).then(res => {
            var data = res.data;
            data.map((item) => {
              item.disabled = true;
            });
            resolve(data)
          });
        };
        if (node.level > 1) return resolve([]);
        if (node.data) {
          this.$axios.get('/system/datadict/tree.htm?id=' + node.data.id, {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            }
          }).then(res => {
            var data = res.data;
            data.map((c, i) => {
              c.parentId = node.data.uniqueCode;
            });
            resolve(data)
          })
        }
      },
      getData: function(id) {
        this.$axios.get('/kt/ktAppraiseItem/getlist.htm?dataId=' + id).then(res => {
          var data = res.data;
          this.loading = false;
          if (data) {
            var defauleIds=[]
            data.map((item)=>{
              defauleIds.push(item.itype);
              if(item.itemJson&&JSON.parse(item.itemJson)){
                JSON.parse(item.itemJson).map((child)=>{
                  defauleIds.push(child.id);
                })
              };
            });
            this.defauleIds=defauleIds;
          } else {
            this.$message.error(data.message);
          }
        })
      },
      getPgxm: function() {

      }
    },
    created: function() {
      // 试卷详情
      if (this.$route.query.id) {
        this.loading = true;
        this.disabled = this.$route.query.isck == '1';
        this.planId = this.$route.query.id;
        this.getData(this.$route.query.id);
      } else {}

      // 滚动条滚动到最顶部
      $('#app').animate({
        scrollTop: 110
      }, 300);
    },
    components: {}
  }
</script>
<style>
  .pxpgInfo {
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 20px;
  }

  .pxpgInfo-header {
    height: 70px;
    border-bottom: 1px solid #efefef;
    padding: 0 30px;
    display: flex;
    align-items: center;
    font-size: 16px;
  }

  .avatar {
    width: 100px;
    height: 140px;
  }

  .sjsc .el-input-number .el-input__inner {
    text-align: left;
  }

  .el-tree-node__content {
    height: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/Pxpg.vue